import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';
import styles from './TeamMembers.module.scss';
import { useId } from '../../../../lib/hooks/useId';

const TeamAccordionItemSkeleton = (props: SkeletonProps) => {
  return <Skeleton className={styles.teamMembersAccordionItemSkeleton} {...props} />;
};

const TeamMembersSkeleton = ({ length = 3 }: { length?: number }) => {
  const skeletonRowId = useId('skeleton-team-accordion-item-');
  const skeletonRows = Array.from({ length }, (_, i) => `${skeletonRowId}${i}`);

  return (
    <div>
      {skeletonRows.map(row => (
        <TeamAccordionItemSkeleton key={row} />
      ))}
    </div>
  );
};

export default TeamMembersSkeleton;
